
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TemplateComponent from "./components/TemplateComponent.vue";

export default defineComponent({
  name: "TemplatesPage",
  components: {
    BreadCrumb,
    TemplateComponent
  },
});
